import React from 'react';

interface WrapperProps {
    condition: boolean;
    version: boolean;
    children: React.ReactNode;
}

interface StylingWrapperProps {
    condition: boolean;
    wrapperClassName?: string;
    children: React.ReactNode;
}

export const Wrapper: React.FC<WrapperProps> = ({
    condition,
    version,
    children
}) => {
    return <>{version ? (condition ? children : null) : children}</>;
};

export const StylingWrapper: React.FC<StylingWrapperProps> = ({
    condition,
    wrapperClassName,
    children
}) => {
    return condition ? (
        <div className={wrapperClassName}>{children}</div>
    ) : (
        <>{children}</>
    );
};
